import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {blueColor, greyishBlue500} from "assets/jss/main";

ShipmentInfosHeader.propTypes = {
    selectedShipment: PropTypes.func
};

function ShipmentInfosHeader({selectedShipment}) {
    return (
        <div style={{display: "flex", flexDirection: "column", marginLeft: "16px"}}>
            <span style={{fontWeight: 600, fontSize: "16px", color: blueColor}}>#{selectedShipment.orderNumber}</span>
            {selectedShipment.lineItems.length > 1 && (
                <span style={{fontWeight: 400, fontSize: "14px", color: greyishBlue500}}>
                    {selectedShipment.lineItems.length} <FormattedMessage id={"wms.packing.articles"}/>
                </span>
            )}
        </div>
    );
}

export default ShipmentInfosHeader;
